<template>
    <Answer/>
</template>
<script>
import Answer from 'place/answer/answer.vue'
export default {
    components:{
        Answer
    }
}
</script>